import { render, staticRenderFns } from "./SelectRequest.vue?vue&type=template&id=8c96dfc0&scoped=true&"
import script from "./SelectRequest.vue?vue&type=script&lang=js&"
export * from "./SelectRequest.vue?vue&type=script&lang=js&"
import style0 from "./SelectRequest.vue?vue&type=style&index=0&id=8c96dfc0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c96dfc0",
  null
  
)

export default component.exports